export default "__VITE_ASSET__BNZtsd8Z__"